import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { AvailableTemplatesDialogComponent } from '../available-templates-dialog/available-templates-dialog.component';

@Component({
  selector: 'app-templated-input-instructions',
  templateUrl: './templated-input-instructions.component.html',
  styleUrl: './templated-input-instructions.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatDialogModule, MatExpansionModule],
})
export class TemplatedInputInstructionsComponent {
  private readonly dialog = inject(MatDialog);

  onViewTemplatesClick() {
    this.dialog.open(AvailableTemplatesDialogComponent, {
      width: '1000px',
      data: { templates: '' },
    });
  }
}
